import React from 'react';
import Modal from '../shared/Modal';
import Formsy from 'formsy-react';
import FormsySimpleInput from '../form/FormsySimpleInput';
import InputAutoComplete from '../form/InputAutoComplete';
import Checkbox from '../form/FormsyCheckbox';
import { menuAPI } from '../../InterfaceAPI/menuAPI';

class ProductEditDetailsModal extends React.Component {
  state = {
    category_name: '',
    availableAllergens: [],
    availableCategories: [],
    availableFormats: [],
    availableVendors: [],
    product: {
      name: '',
      product_category: {},
      product_format: {},
      product_vendor: {},
      allergen_tags: []
    }
  };

  render() {
    const { handleChange, handleAutoCompleteChange, handleSubmit } = this;
    const { isOpen, closeModal } = this.props;
    const {
      product,
      availableCategories,
      availableFormats,
      availableVendors
    } = this.state;
    const { name, product_category, product_format, product_vendor } = product;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className='admin-wrapper'>
          <h2 className="h2 modal__heading">Edit Details</h2>
          <Formsy className="form" onValidSubmit={handleSubmit}>
            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Product Name</p>
                <FormsySimpleInput
                  type="text"
                  name="name"
                  placeholder=""
                  value={name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Category</p>
                <InputAutoComplete
                  type="text"
                  name="product_category"
                  placeholder="Type to Search"
                  value={product_category}
                  onChange={handleAutoCompleteChange}
                  availableItems={availableCategories}
                  itemProp="name"
                  autoComplete="off"
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Purchase Unit</p>
                <InputAutoComplete
                  type="text"
                  name="product_format"
                  placeholder="Type to Search"
                  value={product_format}
                  onChange={handleAutoCompleteChange}
                  availableItems={availableFormats}
                  itemProp="name"
                  autoComplete="off"
                  required
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Vendor</p>
                <InputAutoComplete
                  type="text"
                  name="product_vendor"
                  placeholder="Type to Search"
                  value={product_vendor}
                  onChange={handleAutoCompleteChange}
                  availableItems={availableVendors}
                  itemProp="name"
                  autoComplete="off"
                  required
                />
              </div>
            </div>

            <div className="checkbox-group">
              <p className="p p--bold cms__section-head">Allergens</p>
              <div className="Input form__row--spacer">
                {this.renderAllergens()}
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="form__row-item--half">
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  value="Save"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  renderAllergens() {
    const { isChecked, toggleChecked } = this;
    return this.state.availableAllergens.map(item => (
      <div
        key={item.id}
        className="checkbox-row__item checkbox-row__item--third"
      >
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue checkbox--flex form__row-item--third"
          placeholder={item.tag}
          checked={isChecked(item)}
          onChange={e => toggleChecked(item)}
        />
      </div>
    ));
  }

  handleSubmit = () => {
    this.props.updateProduct(this.state.product);
  };

  isChecked = value => {
    return (
      this.state.product.allergen_tags.findIndex(val => val.id === value.id) >=
      0
    );
  };

  toggleChecked = value => {
    const product = { ...this.state.product };

    if (this.isChecked(value)) {
      // delete
      const index = product.allergen_tags.findIndex(val => val.id === value.id);
      product.allergen_tags = [
        ...product.allergen_tags.slice(0, index),
        ...product.allergen_tags.slice(index + 1, product.allergen_tags.length)
      ];
    }
    // add
    else product.allergen_tags.push(value);

    this.setState({ product });
  };

  handleChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const product = {
      ...this.state.product,
      [name]: value
    };

    this.setState({ product });
  };

  handleAutoCompleteChange = (input, value) => {
    const product = {
      ...this.state.product,
      [input]: value
    };
    this.setState({ product });
  };

  deriveState() {
    const product = { ...this.props.product };

    // this is kind of annoying, deep clone function is an alternative
    // initialize allergens values _without_ reference
    product.allergen_tags =
      'allergen_tags' in this.props.product
        ? [...this.props.product.allergen_tags]
        : [];
    return { product };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);

    menuAPI
      .getAllergens()
      .then(({ allergen_tags: availableAllergens }) =>
        this.setState({ availableAllergens })
      )
      .catch(error => console.log(error));

    menuAPI
      .getProductCategories()
      .then(({ product_categories: availableCategories }) =>
        this.setState({ availableCategories })
      )
      .catch(error => console.log(error));

    menuAPI
      .getProductFormats()
      .then(({ product_formats: availableFormats }) =>
        this.setState({ availableFormats })
      )
      .catch(error => console.log(error));

    menuAPI
      .getProductVendors()
      .then(({ product_vendors: availableVendors }) =>
        this.setState({ availableVendors })
      )
      .catch(error => console.log(error));

    // menuAPI.getCulinaryPreferences().then(result => console.log(result)).catch(error => console.log(error));
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.product !== prevProps.product) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default ProductEditDetailsModal;



// WEBPACK FOOTER //
// ./src/components/product/ProductEditDetailsModal.js